import { Component, Input, OnInit } from '@angular/core';
import { BaseReportCardComponent } from '../base-report-card.component';
import { PastDueGrouping, PastDueViewModel, ReportGenSvc, ReportWithDatesRequest } from 'src/app/services_autogenerated/generated_services';

@Component({
    selector: 'app-past-due',
    templateUrl: './past-due.component.html',
    styleUrls: ['./past-due.component.css'],
    standalone: false
})
export class PastDueComponent extends BaseReportCardComponent implements OnInit {
  @Input() mainColor: string = 'rgb(154,153,109)'
  
  totalsLoading: boolean = true;

  showAllUnderThirty: boolean = false
  showAllThirtyToSixty: boolean = false
  showAllOverSixty: boolean = false;
  
  ranges: PastDueGrouping;

  constructor(private reportService: ReportGenSvc) {
    super();
  }

  ngOnInit() {  
    this.reportService.getPastDue(new ReportWithDatesRequest({
      id: !this.companyWide ? this.employee.id : null,
    })).subscribe(res => {
      this.ranges = res;

      this.totalsLoading = false;
    });
  }

  goToWorkOrder(record: PastDueViewModel) {
    if (record.serviceType === 'Tree Wellness') {
      window.open('wellnessWorkOrderMaintenance/' + record.workOrderId, '_blank');
    } else {
      window.open('workWorkOrderMaintenance/' + record.workOrderId, '_blank');
    }
  }
}
